import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'admin-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  host: {
    class: 'd-flex flex-grow-1 m-n3',
  },
  standalone: false,
})
export class IndexComponent implements OnInit {
  translate = inject(TranslateService);
  private titleService = inject(Title);

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });
  }
}
